export const defaultInjuriesBefore = {
    CRv4Wcgs3bvQi9pl6efF: '',
    bRPhf5No2t6dUqm97B09: ''
};
